import React, { useCallback, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import "./FileManager.scss";
import { resetSession } from "../../redux/auth";
import { UserIcon } from "../../components/Icon";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal
} from "../../components/commons";
import {
  createFolderAction,
  resetFileManagerError,
  resetFileManagerSuccess,
  getChildFoldersAction,
  uploadFileInDriveAction,
  resetFileManagerStatusCode,
  renameFolderAction,
  resetChildFoldersList,
  resetChildFilesList,
  renameFileAction,
  resetFileManagerUploadSuccess,
  resetUploadFileData,
  resetTotalCount,
  deleteFileAndFolderAction,
  hideFileFolderAction,
} from "../../redux/fileManager";
import {
  AddFolderModal,
  FolderBreadCrumbs,
  EmptyDocumentData,
  RenameFolderModal,
  RenameFileModal,
} from "../../components/FileManager";

import {
  AddFolderTypesPayload,
  DeleteFileFolderPayloadType,
  HideFileFolderPayloadType,
  ImageDataType,
  RenameFileTypePayload,
  RenameFolderTypePayload,
  UploadFileTypesPayload,
} from "../../commonTypes/fileManagerTypes";
import { RootState } from "../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import {
  childFileType,
  childFolderType,
} from "../../redux/fileManager/fileManagerTypes";
import { SUCCESS_MESSAGES } from "../../constant/fileManagerConstant";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import ImagePreview from "../../components/FileManager/Files/ImagePreview";
import FileManagerUploadModal from "../../components/commons/Upload/FileManagerUploadModal";
import FilesMap from "../../components/FileManager/Files/FilesFolderMap";
import FolderMap from "../../components/FileManager/Folder/FolderMap";
import {
  GridViewIcon,
  GridViewIconActive,
  ListIcon,
  ListIconActive,
  SearchCancelIcon,
  UploadImgIcon
} from "../../assets/images";
import { withoutValueButtons } from "../../utils/commonFunctions";
import ScrollToTop from "../../components/commons/ScrollToTop";
import {
  ButtonDropdown,
  DropdownToggle
} from "reactstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DeleteConfirmationModal from "../../components/commons/DeleteConfirmationModal";

type pathType = {
  name: string;
  id: number | null;
};

type finalFolderDataType = {
  folder_name: string;
  parent_id: number | null;
  folder_path: pathType[] | [];
};

interface Props {
  history?: any;
  error?: string | null;
  token: string | null;
  statusCode: number | null;
  success: number | null;
  uploadSuccess: number | null;
  fetching: boolean;
  uploadFetching: boolean;
  dispatchResetSession: () => void;
  dispatchCreateFolderAction: (data: AddFolderTypesPayload) => void;
  dispatchRenameFolderAction: (data: RenameFolderTypePayload) => void;
  dispatchRenameFileAction: (data: RenameFileTypePayload) => void;
  dispatchResetFileManagerErrorAction: () => void;
  dispatchResetFileManagerSuccessAction: () => void;
  dispatchResetFileManagerUploadSuccessAction: () => void;
  dispatchGetChildFoldersAction: (data: any) => void;
  dispatchUploadFileinDriveAction: (data: UploadFileTypesPayload) => void;
  dispatchDeleteFileAndFolderAction: (
    data: DeleteFileFolderPayloadType
  ) => void;
  dispatchResetFileManagerStatusCode: () => void;
  dispatchResetChildFoldersListAction: () => void;
  dispatchResetChildFilesListAction: () => void;
  uploadFileData: any;
  dispatchResetUploadFileData: () => void;
  childFiles: childFileType[] | [];
  childFolders: childFolderType[] | [];
  childFilesCount: number;
  totalCount: number;
  isParrentHide:number|null;
  dispatchResetTotalCount: () => void;
  dispatchHideFileFolderAction:(data:HideFileFolderPayloadType)=>void;
}

const DocumentList = ({
  success,
  uploadSuccess,
  fetching,
  uploadFetching,
  statusCode,
  history,
  token,
  error,
  isParrentHide,
  dispatchResetSession,
  dispatchCreateFolderAction,
  dispatchRenameFolderAction,
  dispatchRenameFileAction,
  dispatchResetFileManagerErrorAction,
  dispatchResetFileManagerSuccessAction,
  dispatchGetChildFoldersAction,
  dispatchUploadFileinDriveAction,
  dispatchResetFileManagerStatusCode,
  dispatchResetChildFoldersListAction,
  dispatchResetChildFilesListAction,
  dispatchResetFileManagerUploadSuccessAction,
  uploadFileData,
  dispatchResetUploadFileData,
  childFiles,
  childFolders,
  totalCount,
  dispatchResetTotalCount,
  dispatchDeleteFileAndFolderAction,
  dispatchHideFileFolderAction
}: Props) => {
  const search = useLocation().search;
  const clientCodeFromParams = new URLSearchParams(search).get("client_code");
  const companyNameFromParams = new URLSearchParams(search).get("company_name");
  const searchFromParams = new URLSearchParams(search).get("search");
  const client_code: number = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : clientCodeFromParams;
  const historySearch: string = history?.location?.state?.searchData
    ? history?.location?.state?.searchData
    : "";
  const company_name: string = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyNameFromParams;

  const urlData = useParams<{
    folder_id?: string | undefined;
    data?: string | undefined;
  }>();
  let folder_id = urlData?.folder_id;
  let searchUrlData = urlData?.data;
  const folderDetail = history?.location?.state?.folder;
  const inputElement = React.useRef<HTMLInputElement>(null);
  

  // Remaining States
  const [modal, toggleModal] = useState<boolean>(false);
  const [showAddFolderModal, setShowAddFolderModal] = useState<boolean>(false);
  const [showDeleteIcon, setShowDeleteIcon] = useState<boolean>(false);
  const [showViewMore, setShowViewMore] = useState<boolean>(false);
  const [showViewMoreFiles, setShowViewMoreFiles] = useState<boolean>(false);
  const [viewMoreFolderId, setViewMoreFolderId] = useState<
    number | null | undefined
  >(null);
  const [viewMoreFileId, setViewMoreFileId] = useState<
    number | null | undefined
  >(null);
  const [showRenameFolderModal, setShowRenameFolderModal] =
    useState<boolean>(false);
  const [showRenameFileModal, setShowRenameFileModal] =
    useState<boolean>(false);
  const [folderRenameModalData, setFolderRenameModalData] =
    useState<childFolderType | null>(null);
  const [fileRenameModalData, setFileRenameModalData] = useState(null);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);
  const [uploadErrorArray, setUploadErrorArray] = useState([]);
  const [searchData, setSearchData] = useState(historySearch || "");
  const [showSearchData, setShowSearchData] = useState(historySearch || "");
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [isFilePresent, setIsFilePresent] = useState<boolean>(false);
  const [fileData, setFileData] = useState({ id: null, dir_id: 0 });
  const [tableView, setTableView] = useState(
    history?.location?.state?.tableView || false
  );
  //========== User Management ==========//
  const [isUploadPresent, setIsUploadPresent] = useMenuCheck();
  const [isAddFolderPresent, setIsAddFolderPresent] = useMenuCheck();
  const [isRenameFolderPresent, setisRenameFolderPresent] = useMenuCheck();
  const [isRenameFilePresent, setisRenameFilePresent] = useMenuCheck();
  const [isFileAndFolderDelete, setisFileAndFolderDelete] = useMenuCheck();
  const [isHideAndShowFileFolderPresent , setIsHideAndShowFileFolderPresent] = useMenuCheck();
  //====================//

  useEffect(() => {
    if (inputElement && inputElement?.current && searchUrlData) {
      inputElement?.current.focus();
    }
    setIsUploadPresent("Upload File", "menu");
    setIsAddFolderPresent("Create Folder", "menu");
    setisRenameFolderPresent("Rename Folder", "menu");
    setisRenameFilePresent("Rename File", "menu");
    setisFileAndFolderDelete("Delete File And Folder", "menu");
    setIsHideAndShowFileFolderPresent("Hide File And Folder", "menu")
    dispatchResetChildFoldersListAction();
    dispatchResetChildFilesListAction();
    dispatchResetUploadFileData();
    dispatchResetTotalCount();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatchResetFileManagerStatusCode();
    dispatchResetFileManagerErrorAction();
    dispatchResetFileManagerSuccessAction();
    setShowViewMore(false);
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folder_id]);

  useEffect(() => {
    setUploadSuccessArray([]);
    dispatchResetUploadFileData();
    if (!modal) {
      setUploadSuccessArray([]);
      setUploadErrorArray([]);
      dispatchResetFileManagerSuccessAction();
      dispatchResetChildFoldersListAction();
      dispatchResetUploadFileData();
      let finalData = {
        client_code,
        folder_id: folder_id ? folder_id : 0,
        token,
        search_term: searchData,
      };
      dispatchGetChildFoldersAction(finalData);
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, folder_id]);

  useEffect(() => {
    if (uploadFileData) {
      if (Object.values(uploadFileData)?.length) {
        setUploadSuccessArray([
          ...uploadSuccessArray,
          uploadFileData?.file_name,
        ]);
      }
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadFileData]);

  useEffect(() => {
    if (searchData || searchFromParams?.trim()?.length) {
      dispatchResetChildFoldersListAction();
      dispatchResetChildFilesListAction();
      if (client_code && token) {
        let finalData = {
          client_code,
          folder_id: folder_id ? folder_id : 0,
          token,
          search_term: searchData,
        };
        dispatchGetChildFoldersAction(finalData);
      }
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData, searchFromParams]);

  useEffect(() => {
    if (modal || showAddFolderModal) {
      setShowSearchData("");
    }
  }, [modal, showAddFolderModal]);
  const handleCallResetSessionFunctions = () => {
    dispatchResetFileManagerStatusCode();
    dispatchResetSession();
  };


  const handleToggleViewMore = useCallback(() => {
    setShowViewMore(!showViewMore);
    setShowViewMoreFiles(false);
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showViewMore, showViewMoreFiles]);

  const handleToggleViewMoreFiles = useCallback(() => {
    setShowViewMoreFiles(!showViewMoreFiles);
    setShowViewMore(false);
  }, [showViewMoreFiles]);

  const handleSetViewMoreFolderId = useCallback(
    (folderId: number | null | undefined) => {
      setViewMoreFolderId(folderId);
    },
     // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewMoreFileId]
  );

  const handleSetViewMoreFileId = useCallback(
    (fileId: number | null | undefined) => {
      setViewMoreFileId(fileId);
      
    },
     // eslint-disable-next-line react-hooks/exhaustive-deps
    [viewMoreFileId]
  );

  const handleSetRenameModalData = useCallback(
    (folderData: childFolderType) => {
      setFolderRenameModalData(folderData);
    },
     // eslint-disable-next-line react-hooks/exhaustive-deps
    [folderRenameModalData]
  );

  const handleSetFileRenameModalData = useCallback(
    (fileData: any) => {
      setFileRenameModalData(fileData);
    },
     // eslint-disable-next-line react-hooks/exhaustive-deps
    [fileRenameModalData]
  );

  const getImageDetails = useCallback(
    (data: any) => {
      setImageDetails(data);
    },
     // eslint-disable-next-line react-hooks/exhaustive-deps
    [imageDetails]
  );

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };

  const showUploadModal = () => {
    toggleModal(!modal);
  };

  const toggleAddFolderModal = () => {
    setShowAddFolderModal(!showAddFolderModal);
  };

  const toggleRenameFolderModal = useCallback(() => {
    setShowRenameFolderModal(!showRenameFolderModal);
  }, [showRenameFolderModal]);
  const toggleRenameFileModal = useCallback(() => {
    setShowRenameFileModal(!showRenameFileModal);
  }, [showRenameFileModal]);

  const renderDocumentList = () => {
    return (
      <>
        <FilesMap
          childFiles={childFiles}
          document={document}
          isParrentHide={isParrentHide}
          showDeleteIcon={showDeleteIcon}
          handleToggleViewMoreFiles={handleToggleViewMoreFiles}
          handleSetViewMoreFileId={handleSetViewMoreFileId}
          showViewMoreFiles={showViewMoreFiles}
          toggleRenameFileModal={toggleRenameFileModal}
          viewMoreFileId={viewMoreFileId}
          handleSetFileRenameModalData={handleSetFileRenameModalData}
          isRenameFilePresent={isRenameFilePresent}
          getImageDetails={getImageDetails}
          tableView={tableView}
          childFolders={childFolders}
          client_code={client_code}
          company_name={company_name}
          viewMoreFolderId={viewMoreFolderId}
          handleToggleViewMore={handleToggleViewMore}
          handleSetViewMoreFolderId={handleSetViewMoreFolderId}
          showViewMore={showViewMore}
          handleSetRenameModalData={handleSetRenameModalData}
          toggleRenameFolderModal={toggleRenameFolderModal}
          isRenameFolderPresent={isRenameFolderPresent}
          setSearchData={setSearchData}
          setShowSearchData={setShowSearchData}
          setShowViewMoreFiles={setShowViewMoreFiles}
          handleDeleteFileAndFolder={handleDeleteFileAndFolder}
          isFileAndFolderDelete={isFileAndFolderDelete}
          handleHideFileFolder={handleHideFileFolder}
          handleUnHideFileFolder={handleUnHideFileFolder}
          isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}

        />
      </>
    );
  };

  const renderFileDocumentList = () => {
    return (
      <>
        <FilesMap
          childFiles={childFiles}
          document={document}
          isParrentHide={isParrentHide}
          showDeleteIcon={showDeleteIcon}
          handleToggleViewMoreFiles={handleToggleViewMoreFiles}
          handleSetViewMoreFileId={handleSetViewMoreFileId}
          showViewMoreFiles={showViewMoreFiles}
          toggleRenameFileModal={toggleRenameFileModal}
          viewMoreFileId={viewMoreFileId}
          handleSetFileRenameModalData={handleSetFileRenameModalData}
          isRenameFilePresent={isRenameFilePresent}
          getImageDetails={getImageDetails}
          tableView={tableView}
          childFolders={childFolders}
          client_code={client_code}
          company_name={company_name}
          viewMoreFolderId={viewMoreFolderId}
          handleToggleViewMore={handleToggleViewMore}
          handleSetViewMoreFolderId={handleSetViewMoreFolderId}
          showViewMore={showViewMore}
          handleSetRenameModalData={handleSetRenameModalData}
          toggleRenameFolderModal={toggleRenameFolderModal}
          isRenameFolderPresent={isRenameFolderPresent}
          setSearchData={setSearchData}
          setShowSearchData={setShowSearchData}
          setShowViewMoreFiles={setShowViewMoreFiles}
          handleDeleteFileAndFolder={handleDeleteFileAndFolder}
          isFileAndFolderDelete={isFileAndFolderDelete}
          handleHideFileFolder={handleHideFileFolder}
          handleUnHideFileFolder={handleUnHideFileFolder}
          isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}

        />
      </>
    );
  };

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "folder_created":
        return setSuccessMessage(SUCCESS_MESSAGES[0].message);
      case "file_uploaded":
        return setSuccessMessage(SUCCESS_MESSAGES[1].message);
      case "rename_folder":
        return setSuccessMessage(SUCCESS_MESSAGES[2].message);
      case "rename_file":
        return setSuccessMessage(SUCCESS_MESSAGES[3].message);
      case "delete_file":
        return setSuccessMessage(SUCCESS_MESSAGES[4].message);
      case "delete_folder":
        return setSuccessMessage(SUCCESS_MESSAGES[5].message);
      case "hide_folder":
        return setSuccessMessage(SUCCESS_MESSAGES[6].message);
      case "hide_file":
        return setSuccessMessage(SUCCESS_MESSAGES[7].message);
      case "unHide_folder":
        return setSuccessMessage(SUCCESS_MESSAGES[8].message);
      case "unHide_file":
        return setSuccessMessage(SUCCESS_MESSAGES[9].message);
      default:
        return setSuccessMessage("Document Created Successfully!");
    }
  };

  const handleCreateFolder = (data: finalFolderDataType) => {
    if (token && client_code) {
      let finalData = {
        ...data,
        client_code,
        token,
      };
      setShowAddFolderModal(false);
      dispatchCreateFolderAction(finalData);
      handleSuccessMessage("folder_created");
    }
  };

  const handleRenameFolder = (data: any) => {
    let finalData = {
      token,
      folder_id: data?.folder_id,
      folder_name: data?.folder_name,
    };

    if (token && data?.folder_id && data?.folder_name) {
      setShowRenameFolderModal(false);
      dispatchRenameFolderAction(finalData);
      handleSuccessMessage("rename_folder");
    }
  };
 
  const handleHideFileFolder =(data:any)=>{
    const isFile = !!data["file_name"];
    let finalData = {
      token,
      id: data?.id,
      client_code,
      type: isFile ? "file" : "folder",
      to_hide:'1'
    }
    dispatchHideFileFolderAction(finalData)
    handleSuccessMessage(`${isFile ? "hide_file" : "hide_folder"}`);

    
  }

  // handleUnHideFileFolder
  const handleUnHideFileFolder =(data:any)=>{
    const isFile = !!data["file_name"];

    let finalData = {
      token,
      id: data?.id,
      client_code,
      type: isFile ? "file" : "folder",
      to_hide:'0'
    }
    dispatchHideFileFolderAction(finalData)
    handleSuccessMessage(`${isFile ? "unHide_file" : "unHide_folder"}`);

    
  }


  const handleRenameFile = (data: any) => {
    let finalData = {
      token,
      client_code,
      id: data?.id,
      file_name: data?.file_name,
    };

    if (token && data?.id && data?.file_name) {
      setShowRenameFileModal(false);
      dispatchRenameFileAction(finalData);
      handleSuccessMessage("rename_file");
    }
  };

  const handleUploadFile = (data: UploadFileTypesPayload) => {
    let finalData: UploadFileTypesPayload = {
      ...data,
      client_code,
      token,
      folder_id: folder_id,
    };

    if (token && client_code) {
      dispatchResetFileManagerUploadSuccessAction();
      dispatchUploadFileinDriveAction(finalData);
    }
  };

  const callbackAfterUploadAllFile = () => {
    setUploadSuccessArray([]);
    setUploadErrorArray([]);
    dispatchResetFileManagerSuccessAction();
    dispatchResetChildFoldersListAction();
    toggleModal(false);
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    if (e.key === "Enter" && value?.length) {
      setSearchData(() => value);
      history.push({
        pathname: `/file-managers/${client_code}/search=${encodeURIComponent(
          e.target.value
        )}`,
        state: {
          client_code,
          company_name,
          searchData: e.target.value,
          tableView,
        },
      });
    }
    if (
      value?.length === 0 &&
      !withoutValueButtons?.includes(e.keyCode) &&
      searchUrlData?.length
    ) {
      setSearchData("");
      setShowSearchData("");
      history.push({
        pathname: `/file-manager/${client_code}/folder/${0}`,
        state: { client_code, company_name },
      });
    }
  };

  const handleDeleteSearch = () => {
    setSearchData("");
    setShowSearchData("");
    history.push({
      pathname: `/file-manager/${client_code}/folder/${0}`,
      state: { client_code, company_name },
    });
  };

  //File and Folder delete funtionality
  const handleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };

  const handleDeleteFileAndFolder = (data: any) => {
    setFileData({ ...data });
    if (data["file_name"]) {
      setIsFilePresent(true);
    } else {
      setIsFilePresent(false);
    }
    handleConfirmationModal();
  };

  const handleDelete = () => {
    if (token && client_code && fileData?.id) {
      let finalData = {
        token,
        client_code,
        id: fileData?.id,
        type: isFilePresent ? "file" : "folder",
      };
      dispatchDeleteFileAndFolderAction(finalData);
    }
    handleSuccessMessage(`${isFilePresent ? "delete_file" : "delete_folder"}`);
    handleConfirmationModal();
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => handleCallResetSessionFunctions()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401 && error?.includes("file_name")) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="File name should be less than 250 characters."
            buttonText="OK"
            onPress={() => {
              dispatchResetFileManagerStatusCode();
              dispatchResetFileManagerErrorAction();
            }}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetFileManagerStatusCode();
              dispatchResetFileManagerErrorAction();
            }}
          />
        );
      }
    }

    if (success === 1) {
      dispatchResetFileManagerSuccessAction();
      dispatchResetChildFoldersListAction();
      toast.success(successMessage, {
        duration: 2000,
      });
      let finalData = {
        client_code,
        folder_id: folder_id ? folder_id : 0,
        token,
        search_term: searchData,
      };

      dispatchGetChildFoldersAction(finalData);
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="File Manager" />
        <div className="d-flex align-items-center">
          {client_code ? (
            <>
              <UserIcon /> &nbsp;
              {company_name} {"(" + client_code + ")"}
            </>
          ) : null}
        </div>
      </div>

      <div className="col-md-12 mt-4">
        <div className="content-area">
          <div className="mb-4">
            <h6
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: 500,
                marginTop: "3px",
              }}
            >
              File Manager
            </h6>
            {!fetching && (
              <span
                style={{ color: "#7c8db0", fontSize: "13px", fontWeight: 500 }}
              >
                Total {totalCount} Files/Folder found
              </span>
            )}
          </div>
          <div
            className="mb-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginRight: "32px",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", width: "70%" }}>
              <div className="w-50" style={{ position: "relative" }}>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search..."
                  onKeyUp={(e) => handleSearch(e)}
                  onChange={(e) => setShowSearchData(e.target.value)}
                  style={{ paddingRight: "2rem" }}
                  value={showSearchData}
                  ref={inputElement}
                />
                {showSearchData?.length ? (
                  <span
                    style={{ position: "absolute", top: "8px", right: "25px" }}
                  >
                    <img
                      src={SearchCancelIcon}
                      alt="cancel-icon"
                      onClick={handleDeleteSearch}
                      style={{ cursor: "pointer" }}
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="ml-4">
                <div className="d-flex flex-row justify-content-end mr-5">
                  {!searchUrlData && isUploadPresent && (
                    <button
                      className="btn btn-primary mr-3"
                      onClick={showUploadModal}
                    >
                      <img src={UploadImgIcon} alt="upload" /> Upload File
                    </button>
                  )}

                  {!searchUrlData && isAddFolderPresent && (
                    <button
                      className="btn btn-outline"
                      onClick={toggleAddFolderModal}
                    >
                      + New Folder
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div
              className="toggle-grid-table-container"
              style={{ width: "100px" }}
            >
              <ButtonDropdown
                toggle={() => {
                  setTableView(false);
                  setShowViewMoreFiles(false);
                  setShowViewMore(false);
                }}
                className="download-report-btn"
                style={
                  !tableView
                    ? {
                        color: "#dd4433",
                        backgroundColor: "#fff6f5",
                      }
                    : {}
                }
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={
                    <Tooltip id="button-view-download-invoice">
                      Grid View
                    </Tooltip>
                  }
                >
                  <DropdownToggle
                    caret
                    outline
                    style={
                      !tableView
                        ? {
                            color: "#dd4433",
                            backgroundColor: "#fff6f5",
                            border: "1px solid#dd4433",
                          }
                        : { border: "1px solid#bfcbe1" }
                    }
                  >
                    <img
                      src={!tableView ? GridViewIconActive : GridViewIcon}
                      alt="list-icon"
                    />
                  </DropdownToggle>
                </OverlayTrigger>
              </ButtonDropdown>
              <ButtonDropdown
                toggle={() => {
                  setTableView(true);
                  setShowViewMoreFiles(false);
                  setShowViewMore(false);
                }}
                className="download-report-btn"
                style={
                  tableView
                    ? {
                        color: "#dd4433",
                        backgroundColor: "#fff6f5",
                      }
                    : {}
                }
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={
                    <Tooltip id="button-view-download-invoice">
                      Table View
                    </Tooltip>
                  }
                >
                  <DropdownToggle
                    caret
                    outline
                    style={
                      tableView
                        ? {
                            color: "#dd4433",
                            backgroundColor: "#fff6f5",
                            border: "1px solid#dd4433",
                          }
                        : { border: "1px solid#bfcbe1" }
                    }
                  >
                    <img
                      src={tableView ? ListIconActive : ListIcon}
                      alt="list-icon"
                    />
                  </DropdownToggle>
                </OverlayTrigger>
              </ButtonDropdown>
            </div>
          </div>
          <FolderBreadCrumbs
            client_code={client_code}
            company_name={company_name}
            folder={folderDetail}
          />
          {childFolders?.length === 0 && childFiles?.length === 0 ? (
            <EmptyDocumentData
              toggleAddFolderModal={toggleAddFolderModal}
              handleUploadFile={handleUploadFile}
              imageWidth="25%"
              documentList={childFiles}
              client_code={client_code}
              isAddFolderPresent={isAddFolderPresent}
              isUploadPresent={isUploadPresent}
            />
          ) : (
            <>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-1">
                      {/* commented for future use */}
                      {/* <div className="delete-files mr-3" onClick={handleToggleDeleteIcon}>
											<i className="fas fa-trash mr-2 delete-file-icon"></i>
											Delete
										</div> */}
                    </div>
                  </div>
                  {childFolders?.length && !tableView ? (
                    <h2 className="mb-3 mt-3" style={{ fontSize: "19px" }}>
                      All Folders
                    </h2>
                  ) : (
                    ""
                  )}
                  {!tableView && (
                    <div
                      className="d-flex flex-row flex-wrap mb-4"
                      style={{ margin: "-10px" }}
                    >
                      <FolderMap
                        childFolders={childFolders}
                        client_code={client_code}
                        isParrentHide={isParrentHide}
                        company_name={company_name}
                        viewMoreFolderId={viewMoreFolderId}
                        handleToggleViewMore={handleToggleViewMore}
                        handleSetViewMoreFolderId={handleSetViewMoreFolderId}
                        showViewMore={showViewMore}
                        handleSetRenameModalData={handleSetRenameModalData}
                        toggleRenameFolderModal={toggleRenameFolderModal}
                        isRenameFolderPresent={isRenameFolderPresent}
                        setSearchData={setSearchData}
                        setShowSearchData={setShowSearchData}
                        setShowViewMore={setShowViewMore}
                        setShowViewMoreFiles={setShowViewMoreFiles}
                        handleDeleteFileAndFolder={handleDeleteFileAndFolder}
                        isFileAndFolderDelete={isFileAndFolderDelete}
                        handleHideFileFolder={handleHideFileFolder}
                        handleUnHideFileFolder={handleUnHideFileFolder}
                        isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}
                      />
                    </div>
                  )}
                  {!fetching && !tableView && childFiles?.length > 0 && (
                    <>
                      {childFiles?.length ? (
                        <h2 className="mb-3" style={{ fontSize: "19px" }}>
                          All Files
                        </h2>
                      ) : (
                        ""
                      )}
                      <div
                        className="d-flex flex-row flex-wrap"
                        style={{ margin: "-10px" }}
                      >
                        {renderDocumentList()}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
          {childFolders?.length || childFiles?.length ? (
            <>
              {tableView && renderFileDocumentList()}
              <ScrollToTop />{" "}
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      {modal ? (
        <FileManagerUploadModal
          modal={modal}
          toggleModal={showUploadModal}
          client_code={client_code}
          token={token}
          handleUploadFile={handleUploadFile}
          currentFolder={folderDetail}
          isDraggableModal
          acceptedFiles="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
          supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
          uploadSuccess={uploadSuccess}
          uploadFetching={uploadFetching}
          uploadSuccessArray={uploadSuccessArray}
          dispatchResetUploadFileData={dispatchResetUploadFileData}
          callbackAfterUploadAllFile={callbackAfterUploadAllFile}
        />
      ) : null}
      {showAddFolderModal && (
        <AddFolderModal
          isOpen={showAddFolderModal}
          toggleAddFolderModal={toggleAddFolderModal}
          handleCreateFolder={handleCreateFolder}
          currentFolder={folderDetail}
        />
      )}
      {showRenameFolderModal && (
        <RenameFolderModal
          isOpen={showRenameFolderModal}
          toggleRenameFolderModal={toggleRenameFolderModal}
          handleRenameFolder={handleRenameFolder}
          currentFolder={folderRenameModalData}
        />
      )}
      {showRenameFileModal && (
        <RenameFileModal
          handleRenameFile={handleRenameFile}
          isOpen={showRenameFileModal}
          toggleRenameFileModal={toggleRenameFileModal}
          currentFile={fileRenameModalData}
        />
      )}
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
      {imageDetails?.imageUrl?.length != 0 && (
        <ImagePreview
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
        />
      )}
      {showConfirmationModal && (
        <DeleteConfirmationModal
          toggle={() => {
            handleConfirmationModal();
          }}
          isOpen={showConfirmationModal}
          title={`Delete ${isFilePresent ? "File" : "Folder"}?`}
          message={`Are you sure you want to delete this
          ${
            isFilePresent
              ? " file?"
              : " folder? Deleting it will also erase all files and subfolders contained within"
          }`}
          onPressConfirm={() => {
            handleDelete();
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.fileManager.fetching,
  uploadFetching: state.fileManager.uploadFetching,
  error: state.fileManager.error,
  success: state.fileManager.success,
  uploadSuccess: state.fileManager.uploadSuccess,
  statusCode: state.fileManager.statusCode,
  uploadFileData: state.fileManager.uploadFileData,
  childFolders: state.fileManager.childFolders,
  childFiles: state.fileManager.childFiles,
  childFilesCount: state.fileManager.childFilesCount,
  totalCount: state.fileManager.totalCount,
  isParrentHide:state.fileManager.isParrentHide
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFileManagerStatusCode: () =>
    dispatch(resetFileManagerStatusCode()),
  dispatchCreateFolderAction: (data: AddFolderTypesPayload) =>
    dispatch(createFolderAction(data)),
  dispatchUploadFileinDriveAction: (data: UploadFileTypesPayload) =>
    dispatch(uploadFileInDriveAction(data)),
  dispatchResetFileManagerErrorAction: () => dispatch(resetFileManagerError()),
  dispatchResetFileManagerSuccessAction: () =>
    dispatch(resetFileManagerSuccess()),
  dispatchResetFileManagerUploadSuccessAction: () =>
    dispatch(resetFileManagerUploadSuccess()),
  dispatchGetChildFoldersAction: (data: any) =>
    dispatch(getChildFoldersAction(data)),
  dispatchRenameFolderAction: (data: RenameFolderTypePayload) =>
    dispatch(renameFolderAction(data)),
  dispatchRenameFileAction: (data: RenameFileTypePayload) =>
    dispatch(renameFileAction(data)),
  dispatchDeleteFileAndFolderAction: (data: DeleteFileFolderPayloadType) =>
    dispatch(deleteFileAndFolderAction(data)),
  dispatchResetChildFoldersListAction: () => dispatch(resetChildFoldersList()),
  dispatchResetChildFilesListAction: () => dispatch(resetChildFilesList()),
  dispatchResetUploadFileData: () => dispatch(resetUploadFileData()),
  dispatchResetTotalCount: () => dispatch(resetTotalCount()),
  dispatchHideFileFolderAction:(data:HideFileFolderPayloadType)=> dispatch(hideFileFolderAction(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentList);
